module.exports = __webpack_public_path__ + "media/images/cover/key-house-5b58fa0e8f619d6b5df5c29ce5c88d84.jpg";